const DEFAULT_AFTER_LOGIN = '/user/orders';

// Only same-origin absolute paths are accepted, so a crafted ?redirect= cannot
// send the photographer to another site after login.
export function isSafeRedirectPath(value) {
  return typeof value === 'string'
    && value.startsWith('/')
    && !value.startsWith('//')
    && !value.includes('\\')
    && !/[\u0000-\u001f]/.test(value);
}

export function postLoginPath(search = '') {
  const target = new URLSearchParams(search).get('redirect');
  return isSafeRedirectPath(target) ? target : DEFAULT_AFTER_LOGIN;
}

function withRedirect(path, target, extra = {}) {
  const params = new URLSearchParams();
  if (isSafeRedirectPath(target)) params.set('redirect', target);
  Object.entries(extra).forEach(([name, value]) => {
    if (value) params.set(name, value);
  });
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

// method=wechat opens the WeChat QR login straight away.
export function loginPathFor(target, { method } = {}) {
  return withRedirect('/login', target, { method });
}

export function signupPathFor(target) {
  return withRedirect('/signup', target);
}

// Carries an existing ?redirect= from one auth page to the next.
export function redirectTargetFrom(search = '') {
  const target = new URLSearchParams(search).get('redirect');
  return isSafeRedirectPath(target) ? target : null;
}

// One-time selection claim links put their token in the fragment: #claim=<token>
export function readClaimToken(hash = '') {
  const token = new URLSearchParams(String(hash).replace(/^#/, '')).get('claim');
  return token && /^[A-Za-z0-9_-]{43}$/.test(token) ? token : null;
}
